var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTickIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#49B393",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3402 19.6851C45.7627 20.124 46 20.7191 46 21.3396C46 21.9601 45.7627 22.5552 45.3402 22.9941L29.8334 44.3148C29.4108 44.7535 28.8377 45 28.2401 45C27.6426 45 27.0695 44.7535 26.6469 44.3148L17.6326 34.9545C17.2221 34.5131 16.995 33.922 17.0001 33.3084C17.0052 32.6949 17.2422 32.1079 17.6601 31.6741C18.0779 31.2402 18.6431 30.9941 19.234 30.9887C19.8249 30.9834 20.3941 31.2193 20.8191 31.6455L28.2401 39.3515L42.1536 19.6851C42.5763 19.2464 43.1494 19 43.7469 19C44.3445 19 44.9176 19.2464 45.3402 19.6851Z",
    fill: "#49B393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickIndicator);
export default __webpack_public_path__ + "static/media/GreenTickIndicator.99212622834de5d9b6d77f6985c98a26.svg";
export { ForwardRef as ReactComponent };